export default __webpack_public_path__ + "static/rive-68288ad964ad168ddcac477e88d83e78.wasm";